<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <label tag="div">Nome</label>
            <b-form-input type="text"
                         placeholder="Nome"
                         v-model="form.nome"
                         name="nome">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>
            <label tag="div">CNPJ</label>
            <b-form-input type="text"
                         placeholder="CNPJ"
                         v-model="form.cnpj"
                         name="cnpj">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cnpj')" v-if="form.errors.has('cnpj')"></b-form-feedback>
            <label tag="div">CPF</label>
            <b-form-input type="text"
                         placeholder="CPF"
                         v-model="form.cpf"
                         name="cpf">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cpf')" v-if="form.errors.has('cpf')"></b-form-feedback>
            <label tag="div">Endereço</label>
            <b-form-input type="text"
                         placeholder="Endereço"
                         v-model="form.endereco"
                         name="endereco">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('endereco')" v-if="form.errors.has('endereco')"></b-form-feedback>
            <label tag="div">IE</label>
            <b-form-input type="text"
                         placeholder="IE"
                         v-model="form.ie"
                         name="ie">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('ie')" v-if="form.errors.has('ie')"></b-form-feedback>
            <label tag="div">Município</label>
            <b-form-input type="text"
                         placeholder="Município"
                         v-model="form.municipio"
                         name="municipio">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('municipio')" v-if="form.errors.has('municipio')"></b-form-feedback>
            <label tag="div">UF</label>
            <b-form-input type="text"
                         placeholder="UF"
                         v-model="form.uf"
                         name="uf">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('uf')" v-if="form.errors.has('uf')"></b-form-feedback>
            <label>Transportadora</label>
            <multiselect v-model="transportadoraSelected"
            :options-limit="300"
            :limit="2"
            :limit-text="limitText"
            :options="optionsTransportadora"
            track-by="value"
            label="label"
            id="transportadora"
            :hide-selected="true"
            placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :loading="isLoadingTransportadora"
            @search-change="listaTransportadora"
            ></multiselect>
            <b-form-feedback v-text="form.errors.get('pessoa_id_for')" v-if="form.errors.has('pessoa_id_for')"></b-form-feedback>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import { formatCNPJFromParts } from "../utils";


export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      optionsTransportadora: [],
      transportadoraSelected: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingTransportadora: false,
      form: new Form({
            cnpj: '',
            nome: '',
            endereco: '',
            ie: '',
            municipio: '',
            uf: '',
            cpf: '',
            docfis_id: [],
                   }),
     helpForm: new Form({search:'',}),
     fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    transportadoraSelected(obj) {
        if(obj != null)
        {
            this.form.cnpj = obj.cnpj;
            this.form.nome = obj.nome;
            this.form.ie = obj.ie;
            this.form.endereco = obj.endereco;
            this.form.uf = obj.uf;
            this.form.municipio = obj.municipio;
            this.form.cpf = obj.cpf;
        }
    }
},

methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        if(this.modal_acao=="l")
        {
           this.onUpdateLote();
        }
        else
        {
            this.onUpdate(this.form.docfisttra_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onEdit (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar transportadora";
      this.modal_botao = "Alterar transportadora";
      this.modal_acao = "u";
      this.transportadoraSelected = null;
      this.form.reset();
      this.form.cnpj = data.cnpj;
      this.form.nome = data.nome;
      this.form.endereco = data.endereco;
      this.form.ie = data.ie;
      this.form.municipio = data.municipio;
      this.form.uf = data.uf;
      this.form.cpf = data.cpf;
      this.form.docfisttra_id = data.docfisttra_id;
      this.$refs.modal_form.show();
    },
    onEditLote (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar transportadora em lote";
      this.modal_botao = "Alterar transportadora em lote";
      this.modal_acao = "l";
      this.transportadoraSelected = null;
      this.form.reset();
      this.form.docfis_id = data;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/montagemcarga/transportadora/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            this.$parent.onFilterReset();
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdateLote()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/montagemcarga/transportadora/lote/update').then(response =>
        {
            new ReturnApi(response, this)
            this.$parent.onFilterReset();
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    listaTransportadora(search) {
        if(search.length>=3)
        {
            this.isLoadingTransportadora = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm.post('/api/pessoa/jsonlist/transportadora').then(response =>
            {
                this.optionsTransportadora = [];
                new ReturnApi(response, this, true, false, false);
                if(response.items.length>0)
                {
                    response.items.forEach((obj)=>
                    {
                        this.optionsTransportadora.push({nome: obj.razao_social, cpf: null, cnpj: this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito), ie: obj.inscricao_estadual, endereco: obj.pessoa.pessoa_endereco[0].endereco, municipio: obj.pessoa.pessoa_endereco[0].municipio.nome, uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,  label: "PJ -"+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id })
                    });
                }
                if(response.itemsF.length>0) {
                    response.itemsF.forEach((obj)=>
                    {
                        this.optionsTransportadora.push({nome: obj.nome, cpf: null, cnpj: null, ie: null, endereco: obj.pessoa.pessoa_endereco[0].endereco, municipio: obj.pessoa.pessoa_endereco[0].municipio.nome, uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,  label: "PF -"+obj.nome+" - "+obj.cpf, pessoa_id: obj.pessoa_id, value: obj.pessoa_id })
                    });
                }
                if(response.itemsE.length>0)
                {
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsTransportadora.push({nome: obj.nome, cpf: null, cnpj: obj.cuit, ie: null, endereco: obj.pessoa.pessoa_endereco[0].endereco, municipio: obj.pessoa.pessoa_endereco[0].municipio.nome, uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,   label: "PE -"+obj.nome+" - "+obj.cd, pessoa_id: obj.pessoa_id, value: obj.pessoa_id })
                    });
                }
                this.isLoadingTransportadora = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
              });
            }
      },
            onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
      },
      limitText (count) {
        return ' e ${count} outros clientes'
      },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>